
import { Image, Text } from "@react-three/drei"
import { mainStore } from "../store"
import { __ } from "../utils"
import { useThree } from "@react-three/fiber"



export default function textCenter({ maxWidth = 4.2, scale = 1, position=[0,0,0], positionX = 0, positionY = 0, positionZ = 0, text, exposant, expFont = false, offsetX = 0, offsetY = 0, fontsOw = false, fontSize = 0.15, lineHeight = 0.8,  exposantHeight = false, children}, props) {

    /**
     * Setup
     */
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const { width } = useThree((state) => state.viewport)
    


    return <group scale={scale} position={position} {...props}>
        <Text
            maxWidth={(width * .9 < maxWidth) ? width : maxWidth}
            anchorX={'42%'}
            anchorY={'-50%'}
            lineHeight={ lineHeight }
            fontSize={ fontSize }
            position={[0 + positionX, 0 + positionY, 1.9 + positionZ]}
            font={fontsOw ? fontsOw : fonts.cm.title}
            color={colors.title}
            textAlign="center"
        >
            { children }
        </Text>


        {
            exposant && <Text
                maxWidth={maxWidth}
                anchorX={'42%'}
                anchorY={'-50%'}
                lineHeight={1.4}
                fontSize={exposantHeight ? exposantHeight : fontSize * 0.5}
                position={[0 + offsetX, 0 + offsetY, 1.9 + positionZ]}
                font={expFont ? expFont : fontsOw ? fontsOw : fonts.cm.title}
                color={colors.title}
                textAlign="center"
            >
                {exposant}
            </Text>
        }

    </group>
}